module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrightx"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('strong', [_vm._v("I WISH")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("© 2015 Nancy Guettier.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Illustrated by Meegan Barnes"), _c('br'), _vm._v("Illustration copyright © 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Published in New York, New York, by Morgan James Publishing. Morgan James and The Entrepreneurial Publisher are trademarks of Morgan James, LLC. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesPublishing.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("The Morgan James Speakers Group can bring authors to your live event. For more information or to book an event visit The Morgan James Speakers Group at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.TheMorganJames-SpeakersGroup.com",
      "target": "_blank"
    }
  }, [_vm._v("www.TheMorganJames-SpeakersGroup.com")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("ISBN 978-1-63047-512-3 paperback"), _c('br'), _vm._v("ISBN 978-1-63047-513-0 eBook"), _c('br'), _vm._v("ISBN 978-1-63047-514-7 hardcover"), _c('br'), _vm._v("Library of Congress Control Number:"), _c('br'), _vm._v("2014921127")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("In an effort to support local communities and raise awareness and funds, Morgan James Publishing donates a percentage of all book sales for the life of each book to Habitat for .Humanity Peninsula and Greater Williamsburg")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-02.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec"
  }, [_vm._v("Get involved today, visit"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.MorganJamesBuilds.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesBuilds.com")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-03.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0